import raveIf from '@magalu/rave/template/rave-if';
import raveExp from '@magalu/rave/template/rave-exp';
import raveJoin from '@magalu/rave/template/rave-join';
import raveReduce from '@magalu/rave/template/rave-reduce';
import raveReplace from '@magalu/rave/template/rave-replace';
import unique from '../../parser/route/unique';

export const getComponents = props => ({
    'header-preconnect-0': {
      name: `Preconnect`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        list: [
          `https://wx.mlcdn.com.br`,
          `https://6590300.fls.doubleclick.net`,
          `https://a-static.mlcdn.com.br`,
          `https://ad.doubleclick.net`,
          `https://analytics.pangle-ads.com`,
          `https://analytics.tiktok.com`,
          `https://analytics.twitter.com`,
          `https://bat.bing.com`,
          `https://c.bing.com`,
          `https://c.clarity.ms`,
          `https://cas.avalon.perfdrive.com`,
          `https://cdn.perfdrive.com`,
          `https://connect.facebook.net`,
          `https://ct.pinterest.com`,
          `https://d.clarity.ms`,
          `https://gum.criteo.com`,
          `https://i.btg360.com.br`,
          `https://s.pinimg.com`,
          `https://sc-static.net`,
          `https://script.hotjar.com`,
          `https://site-content.magazineluiza.com.br`,
          `https://static.ads-twitter.com`,
          `https://static.criteo.net`,
          `https://static.hotjar.com`,
          `https://t.co`,
          `https://tags.creativecdn.com`,
          `https://td.doubleclick.net`,
          `https://tom.mlcdn.com.br`,
          `https://tr.snapchat.com`,
          `https://tr6.snapchat.com`,
          `https://us.creativecdn.com`,
          `https://www.clarity.ms`,
          `https://www.facebook.com`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-preconnect-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-datadog-1': {
      name: `Datadog`,
      from: `@magalu/ecomm-components/rave/scripts/Datadog`,
      props: {
        applicationId: `ebdcd394-ea53-457c-8daf-5659efb01d31`,
        clientToken: `pub65a718f902aee0ef33f464f14d53b149`,
        service: `mixer-hybrid`,
        version: `v${props?.data?.version}`,
        sessionSampleRate: 10,
        sessionReplaySampleRate: 1,
        strategy: `lazyOnload`,
        serviceDomainUrl: `https://mixer-hybrid.magazineluiza.com.br`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-datadog-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-script-2': {
      name: `Script`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        src: `https://wx.mlcdn.com.br/shared/azion/azfp-63fe5.min.js`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-script-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-all-in-3': {
      name: `AllIn`,
      from: `@magalu/ecomm-components/rave/scripts/AllIn`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-all-in-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-criteo-4': {
      name: `Criteo`,
      from: `@magalu/ecomm-components/rave/scripts/Criteo`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-criteo-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-tik-tok-5': {
      name: `TikTok`,
      from: `@magalu/ecomm-components/rave/scripts/TikTok`,
      props: {
        id: `C1I87V1T0U322RQPSRKG`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-tik-tok-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-rtbhouse-6': {
      name: `RTBHouse`,
      from: `@magalu/ecomm-components/rave/scripts/RTBHouse`,
      props: {
        id: `msWukR4UlwKQouZSY8IT`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-rtbhouse-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-stewie-7': {
      name: `Stewie`,
      from: `@magalu/ecomm-components/rave/scripts/Stewie`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-stewie-7`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-spotify-ad-analytics-8': {
      name: `SpotifyAdAnalytics`,
      from: `@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics`,
      props: {
        id: `66f417c2d2344c0980e19d4e7f996073`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-spotify-ad-analytics-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-hotjar-9': {
      name: `Hotjar`,
      from: `@magalu/ecomm-components/rave/scripts/Hotjar`,
      props: {
        id: `4936838`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-hotjar-9`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-10': {
      name: `Loader`,
      from: `@magalu/ecomm-components/rave/Loader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-10`,
      spacing: {
      },
      ssr: false,
    },
    'header-state-loader-11': {
      name: `StateLoader`,
      from: `@magalu/ecomm-components/rave/StateLoader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-11`,
      spacing: {
      },
      ssr: false,
    },
    'header-event-page-view-dispatcher-12': {
      name: `EventPageViewDispatcher`,
      from: `@magalu/ecomm-components/rave/EventPageViewDispatcher`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-event-page-view-dispatcher-12`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-10-children-page-loading-0': {
      name: `PageLoading`,
      from: `@magalu/ecomm-components/components/PageLoading`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-10-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-state-loader-11-children-page-loading-0': {
      name: `PageLoading`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      from: `@magalu/ecomm-components/components/PageLoading`,
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-11-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-ads-resolver-0': {
      name: `AdsResolver`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-ads-resolver-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-zip-code-bar-1': {
      name: `ZipCodeBar`,
      from: `@magalu/ecomm-components/rave/ZipCodeBar`,
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      props: {
        className: `sticky top-[0] z-20`,
      },
      placeholder: {
        name: `Skeleton`,
        from: `@magalu/ecomm-components/components/Skeleton`,
        props: {
          className: `flex justify-center pt-xsm h-[40px] mx-md`,
          config: {
            color: `#B8C1C4`,
            body: [
              [
                {
                  x: 0,
                  y: 0,
                  width: `100%`,
                  height: 32,
                  radius: 4,
                },
              ],
            ],
          },
        },
        id: `content-zip-code-bar-1-placeholder`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-zip-code-bar-1`,
      spacing: {
      },
      ssr: false,
    },
    'content-zip-code-modal-2': {
      name: `ZipCodeModal`,
      from: `@magalu/ecomm-components/rave/ZipCodeModal`,
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-zip-code-modal-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-showcase-3': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `tAb0e13oHy`,
        placeId: `6jIfoBxlkS`,
        productId: props?.route?.query?.productId,
        className: `mx-md mb-xsm max-w-lg cursor-pointer`,
        childrenSettings: {
          title: {
            className: `pb-xsm pt-xsm`,
          },
        },
        checkIfIsSourceProductAds: true,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-showcase-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-4': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-col bg-surface-container-lowest relative`,
      },
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4`,
      spacing: {
      },
      ssr: false,
    },
    'content-row-5': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-col bg-surface-container-lowest`,
      },
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5`,
      spacing: {
      },
      ssr: false,
    },
    'content-trade-in-6': {
      name: `TradeIn`,
      from: `@magalu/ecomm-components/rave/TradeIn`,
      props: {
        className: `mt-xsm flex px-md bg-surface-container-lowest`,
      },
      show: raveExp({
        '===': [
          props?.data?.item?.category?.id,
          `TE`,
        ],
      }),
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-trade-in-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-7': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `mt-xsm flex flex-col bg-surface-container-lowest`,
      },
      show: raveExp({
        '!==': [
          props?.data?.item?.subcategory?.id,
          `SEGR`,
        ],
      }),
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-7`,
      spacing: {
      },
      ssr: false,
    },
    'content-trade-in-8': {
      name: `TradeIn`,
      from: `@magalu/ecomm-components/rave/TradeIn`,
      props: {
        className: `mt-sm flex px-md bg-surface-container-lowest`,
      },
      show: raveExp({
        IN: [
          raveReduce({
            ON_FIELD: [
              `text`,
              props?.data?.item?.offers?.[0]?.badges,
              [
              ],
            ],
          }),
          `smart-troca`,
        ],
      }),
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-trade-in-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-9': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `mt-xsm flex flex-col bg-surface-container-lowest`,
      },
      show: raveExp({
        '!==': [
          props?.data?.item?.subcategory?.id,
          `SEGR`,
        ],
      }),
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-9`,
      spacing: {
      },
      ssr: false,
    },
    'content-row-10': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `mt-xsm py-md flex flex-col bg-surface-container-lowest`,
      },
      show: raveExp({
        '===': [
          props?.data?.item?.subcategory?.id,
          `SEGR`,
        ],
      }),
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-10`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-11': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `mt-xsm py-md flex flex-col bg-surface-container-lowest`,
      },
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      show: raveExp({
        '!==': [
          props?.data?.item?.subcategory?.id,
          `SEGR`,
        ],
      }),
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-11`,
      spacing: {
      },
      ssr: false,
    },
    'content-row-12': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.item?.isBuyBox,
      props: {
        className: `mt-xsm pt-md flex flex-col bg-surface-container-lowest`,
      },
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-12`,
      spacing: {
      },
      ssr: false,
    },
    'content-summary-factsheet-13': {
      name: `SummaryFactsheet`,
      from: `@magalu/ecomm-components/rave/SummaryFactsheet`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-summary-factsheet-13`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-14': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `mt-xsm pt-md flex flex-col bg-surface-container-lowest`,
      },
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-14`,
      spacing: {
      },
      ssr: false,
    },
    'content-review-summary-15': {
      name: `ReviewSummary`,
      from: `@magalu/ecomm-components/rave/ReviewSummary`,
      props: {
        disclaimerText: `Resumo de avaliações de clientes feito pela Lu`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-review-summary-15`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-16': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      show: raveExp({
        '!==': [
          props?.data?.item?.offers?.[0]?.seller?.id,
          `magazineluiza`,
        ],
      }),
      props: {
        className: `mt-xsm pt-md flex flex-col bg-surface-container-lowest`,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-16`,
      spacing: {
      },
      ssr: false,
    },
    'content-showcase-17': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `tAb0e13oHy`,
        placeId: `oMzmVcEhBj`,
        productId: props?.route?.query?.productId,
        className: `mx-md`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-showcase-17`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-18': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `mt-md py-md flex flex-col bg-surface-container-lowest`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-18`,
      spacing: {
      },
      ssr: true,
    },
    'content-ads-showcase-19': {
      name: `AdsShowcase`,
      from: `@magalu/ecomm-components/rave/AdsShowcase`,
      csr: {
        strategy: `onLazyLoading`,
        props: {
          temporary: {
            className: `min-h-[480px]`,
          },
        },
      },
      props: {
        channel: raveIf([
          raveExp({
            '==': [
              props?.route?.deviceInfo?.platform,
              `iOS`,
            ],
          }),
          `H.IOS`,
          `H.ANDROID`,
        ]),
        categories: [
          props?.route?.query?.categoryId,
        ],
        device: `mobile`,
        page: `product`,
        exhibition: `carousel`,
        placement: `selecao_de_produtos_patrocinados_para_voce`,
        slot: `pdp_pp`,
        showcase: {
          config: {
            title: `Explore e aproveite`,
          },
        },
        className: `pb-md`,
        childrenSettings: {
          title: {
            className: `mx-md`,
          },
          showcase: {
            className: `pl-md`,
          },
        },
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-ads-showcase-19`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-20': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `mx-md`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-20`,
      spacing: {
      },
      ssr: true,
    },
    'content-showcase-21': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `tAb0e13oHy`,
        placeId: `Y7WXCUF7g9`,
        productId: props?.route?.query?.productId,
        className: `mx-md`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-showcase-21`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-22': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `mt-md pt-md flex flex-col bg-surface-container-lowest`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-22`,
      spacing: {
      },
      ssr: true,
    },
    'content-showcase-23': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `tAb0e13oHy`,
        placeId: `jafiLM5eNi`,
        productId: props?.route?.query?.productId,
        className: `mx-md`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-showcase-23`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-24': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.questions?.sellerInfo?.enabled,
      props: {
        className: `flex-col mt-xsm gap-sm bg-surface-container-lowest`,
      },
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-24`,
      spacing: {
      },
      ssr: false,
    },
    'content-showcase-25': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `tAb0e13oHy`,
        placeId: `bLJquotBo3`,
        productId: props?.route?.query?.productId,
        className: raveIf([
          raveExp({
            '==': [
              props?.data?.seoPdpContent?.faq,
              null,
            ],
          }),
          `mx-md`,
          `mx-md pb-2xhg`,
        ]),
        includePagination: raveExp({
          '===': [
            props?.route?.cookies?.toggle_product_endless_showcase,
            `true`,
          ],
        }),
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-showcase-25`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-26': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.seoPdpContent?.faq,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      props: {
        className: `mt-xsm py-md flex flex-col bg-surface-container-lowest pb-2xlg`,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-26`,
      spacing: {
      },
      ssr: false,
    },
    'content-row-4-children-media-gallery-0': {
      name: `MediaGallery`,
      from: `@magalu/ecomm-components/rave/MediaGallery`,
      props: {
        preload: true,
        transitionCarouselTime: 100,
        className: `mb-sm`,
      },
      placeholder: {
        name: `Skeleton`,
        from: `@magalu/ecomm-components/components/Skeleton`,
        props: {
          className: `flex justify-center mx-md mt-lg h-[320px]`,
          config: {
            color: `#B8C1C4`,
            body: [
              [
                {
                  x: 0,
                  y: 0,
                  width: `100%`,
                  height: 320,
                  radius: 10,
                },
              ],
            ],
          },
        },
        id: `content-row-4-children-media-gallery-0-placeholder`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4-children-media-gallery-0`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-4-children-row-1': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex-col absolute bottom-xlg right-md gap-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4-children-row-1`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-4-children-row-1-children-seller-chat-button-0': {
      name: `SellerChatButton`,
      from: `@magalu/ecomm-components/rave/SellerChatButton`,
      show: props?.data?.item?.offers?.[0]?.seller?.isChatEnabled,
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-4-children-row-1-children-seller-chat-button-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-4-children-row-1-children-social-share-1': {
      name: `SocialShare`,
      from: `@magalu/ecomm-components/rave/SocialShare`,
      props: {
        useNativeWebShare: true,
        variation: `circle`,
        icon: `icon-share`,
        shareData: {
          title: props?.data?.item?.title,
          text: props?.data?.item?.title,
          icon: `icon-whatsapp-share`,
          url: `https://m.magazineluiza.com.br${props?.route?.asPath}?partner_id=64853&utm_source=pdp_desk&utm_medium=share`,
        },
        socialPlatforms: [
          {
            platform: `facebook`,
            url: `https://m.facebook.com/sharer/sharer.php?u={url}`,
            icon: `icon-facebook`,
          },
          {
            platform: `twitter`,
            url: `https://twitter.com/intent/tweet?text={title}&url={url}`,
            icon: `icon-twitter`,
          },
          {
            platform: `whatsapp`,
            url: `https://wa.me/?text={url}`,
            icon: `icon-whatsapp`,
          },
          {
            platform: `email`,
            url: `mailto:?subject={title}&body={desc}%20{url}`,
            icon: `icon-mail`,
          },
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4-children-row-1-children-social-share-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-4-children-row-2': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `absolute top-md right-md`,
      },
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4-children-row-2`,
      spacing: {
      },
      ssr: false,
    },
    'content-row-4-children-row-2-children-favorite-button-0': {
      name: `FavoriteButton`,
      from: `@magalu/ecomm-components/rave/FavoriteButton`,
      props: {
        variation: `circle`,
        name: props?.data?.item?.title,
        price: props?.data?.item?.offers?.[0]?.price,
        variationId: props?.data?.item?.id,
        className: `max-w-[42px] max-h-[42px]`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4-children-row-2-children-favorite-button-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-5-children-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: raveIf([
          raveExp({
            IN: [
              props?.data?.item?.tags,
              `is_magalu_indica`,
            ],
          }),
          `flex-row mx-sm mr-md mt-xsm items-center justify-between`,
          `flex-row mx-sm mr-md mt-xsm items-center justify-end`,
        ]),
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-row-0`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-5-children-row-0-children-closeness-tag-0': {
      name: `ClosenessTag`,
      id: `content-row-5-children-row-0-children-closeness-tag-0`,
      from: `@magalu/ecomm-components/rave/ClosenessTag`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-5-children-row-0-children-rating-1': {
      name: `Rating`,
      from: `@magalu/ecomm-components/rave/Rating`,
      props: {
        className: `ml-auto`,
        stars: 1,
      },
      placeholder: {
        name: `Skeleton`,
        from: `@magalu/ecomm-components/components/Skeleton`,
        props: {
          config: {
            color: `#B8C1C4`,
            body: [
              [
                {
                  x: 0,
                  y: 0,
                  width: 200,
                  height: 10,
                  radius: 2,
                },
              ],
            ],
          },
        },
        id: `content-row-5-children-row-0-children-rating-1-placeholder`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-row-0-children-rating-1`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-5-children-heading-1': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      placeholder: {
        name: `Skeleton`,
        from: `@magalu/ecomm-components/components/Skeleton`,
        props: {
          className: `flex justify-center h-[20px] mx-md mt-md`,
          config: {
            color: `#B8C1C4`,
            body: [
              [
                {
                  x: 0,
                  y: 0,
                  width: 600,
                  height: 10,
                  radius: 2,
                },
              ],
            ],
          },
        },
        id: `content-row-5-children-heading-1-placeholder`,
      },
      props: {
        as: `h1`,
        title: raveJoin([
          [
            raveExp({
              '??': [
                props?.data?.item?.title,
              ],
            }),
            raveIf([
              props?.data?.item?.reference,
              ` - ${props?.data?.item?.reference}`,
            ]),
          ],
        ]),
        publish: `product:title:click`,
        className: `font-md-regular mx-md text-on-surface-2 break-words mt-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-heading-1`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-5-children-alert-attribute-message-2': {
      name: `AlertAttributeMessage`,
      from: `@magalu/ecomm-components/rave/AlertAttributeMessage`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-alert-attribute-message-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-5-children-attribute-selector-3': {
      name: `AttributeSelector`,
      from: `@magalu/ecomm-components/rave/AttributeSelector`,
      placeholder: {
        name: `Skeleton`,
        from: `@magalu/ecomm-components/components/Skeleton`,
        props: {
          className: `flex justify-center mt-lg h-[100px] mx-md`,
          config: {
            color: `#B8C1C4`,
            body: [
              [
                {
                  x: 0,
                  y: 0,
                  width: 60,
                  height: 60,
                  radius: 4,
                },
              ],
              [
                {
                  x: 0,
                  y: 68,
                  width: 60,
                  height: 10,
                  radius: 2,
                },
              ],
              [
                {
                  x: 72,
                  y: 0,
                  width: 60,
                  height: 60,
                  radius: 4,
                },
              ],
              [
                {
                  x: 72,
                  y: 68,
                  width: 60,
                  height: 10,
                  radius: 2,
                },
              ],
              [
                {
                  x: 144,
                  y: 0,
                  width: 60,
                  height: 60,
                  radius: 4,
                },
              ],
              [
                {
                  x: 144,
                  y: 68,
                  width: 60,
                  height: 10,
                  radius: 2,
                },
              ],
              [
                {
                  x: 216,
                  y: 0,
                  width: 60,
                  height: 60,
                  radius: 4,
                },
              ],
              [
                {
                  x: 216,
                  y: 68,
                  width: 60,
                  height: 10,
                  radius: 2,
                },
              ],
            ],
          },
        },
        id: `content-row-5-children-attribute-selector-3-placeholder`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-attribute-selector-3`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-5-children-offer-timer-tag-4': {
      name: `OfferTimerTag`,
      id: `content-row-5-children-offer-timer-tag-4`,
      from: `@magalu/ecomm-components/rave/OfferTimerTag`,
      csr: {
        props: {
        },
        strategy: `onPageLoading`,
      },
      show: props?.route?.cookies?.toggle_offer_timer,
      props: {
        className: `mx-md mt-2xsm mb-xsm`,
        color: raveIf([
          raveExp({
            '==': [
              props?.route?.headers?.theme,
              `theme-black-friday`,
            ],
          }),
          `brand`,
          `default`,
        ]),
      },
      displayCondition: `show`,
      hasSpacing: false,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-5-children-sell-and-deliver-info-5': {
      name: `SellAndDeliverInfo`,
      from: `@magalu/ecomm-components/rave/SellAndDeliverInfo`,
      props: {
        className: `mb-md mt-sm`,
      },
      placeholder: {
        name: `Skeleton`,
        from: `@magalu/ecomm-components/components/Skeleton`,
        props: {
          className: `flex justify-center mt-md h-[40px] mx-md`,
          config: {
            color: `#B8C1C4`,
            body: [
              [
                {
                  x: 0,
                  y: 0,
                  width: 100,
                  height: 10,
                  radius: 2,
                },
              ],
              [
                {
                  x: 0,
                  y: 20,
                  width: 200,
                  height: 10,
                  radius: 2,
                },
              ],
            ],
          },
        },
        id: `content-row-5-children-sell-and-deliver-info-5-placeholder`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-sell-and-deliver-info-5`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-5-children-seller-detail-6': {
      name: `SellerDetail`,
      from: `@magalu/ecomm-components/rave/SellerDetail`,
      props: {
        basePath: `/lojista/`,
        showChatButton: true,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-seller-detail-6`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-5-children-seller-detail-6-children-showcase-0': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `04g35bsxKp`,
        placeId: `V0sLKqbUyE`,
        sellers: [
          props?.data?.item?.offers?.[0]?.seller?.id,
        ],
        className: `pb-md`,
        childrenSettings: {
          title: {
            className: `mx-md`,
          },
          showcase: {
            className: `mx-md`,
          },
        },
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-seller-detail-6-children-showcase-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-5-children-seller-detail-6-children-showcase-1': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `04g35bsxKp`,
        placeId: `MvQHjXEMqW`,
        sellers: [
          props?.data?.item?.offers?.[0]?.seller?.id,
        ],
        className: `pb-md`,
        childrenSettings: {
          title: {
            className: `mx-md`,
          },
          showcase: {
            className: `mx-md`,
          },
        },
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-seller-detail-6-children-showcase-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-5-children-seller-detail-6-children-showcase-2': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `04g35bsxKp`,
        placeId: `mlQjlNz7px`,
        sellers: [
          props?.data?.item?.offers?.[0]?.seller?.id,
        ],
        className: `pb-md`,
        childrenSettings: {
          title: {
            className: `mx-md`,
          },
          showcase: {
            className: `mx-md`,
          },
        },
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-seller-detail-6-children-showcase-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-5-children-seller-detail-6-children-showcase-3': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `04g35bsxKp`,
        placeId: `aAvdBY8EtD`,
        sellers: [
          props?.data?.item?.offers?.[0]?.seller?.id,
        ],
        className: `pb-md`,
        childrenSettings: {
          title: {
            className: `mx-md`,
          },
          showcase: {
            className: `mx-md`,
          },
        },
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-seller-detail-6-children-showcase-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-5-children-seller-detail-6-children-showcase-4': {
      name: `Showcase`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/Showcase`,
      props: {
        pageId: `04g35bsxKp`,
        placeId: `9yh7br41XQ`,
        sellers: [
          props?.data?.item?.offers?.[0]?.seller?.id,
        ],
        className: `pb-md`,
        childrenSettings: {
          title: {
            className: `mx-md`,
          },
          showcase: {
            className: `mx-md`,
          },
        },
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-5-children-seller-detail-6-children-showcase-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-7-children-product-price-0': {
      name: `ProductPrice`,
      from: `@magalu/ecomm-components/rave/ProductPrice`,
      props: {
        className: `flex px-md pt-md w-full justify-between`,
      },
      placeholder: {
        name: `Skeleton`,
        from: `@magalu/ecomm-components/components/Skeleton`,
        props: {
          className: `flex justify-center mt-xsm h-[60px] mx-md`,
          config: {
            color: `#B8C1C4`,
            body: [
              [
                {
                  x: 0,
                  y: 0,
                  width: 400,
                  height: 10,
                  radius: 2,
                },
              ],
              [
                {
                  x: 0,
                  y: 16,
                  width: 250,
                  height: 10,
                  radius: 2,
                },
              ],
              [
                {
                  x: 0,
                  y: 32,
                  width: 100,
                  height: 10,
                  radius: 2,
                },
              ],
            ],
          },
        },
        id: `content-row-7-children-product-price-0-placeholder`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-7-children-product-price-0`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-7-children-product-tags-1': {
      name: `ProductTags`,
      from: `@magalu/ecomm-components/rave/ProductTags`,
      props: {
        tags: [
          `buy_and_win-v1`,
          `minimum-quantity`,
          `international-purchase`,
        ],
        className: `mx-md w-fit`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-7-children-product-tags-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-7-children-import-taxes-2': {
      name: `ImportTaxes`,
      from: `@magalu/ecomm-components/rave/ImportTaxes`,
      show: raveExp({
        '&&': [
          {
            '??': [
              props?.data?.item?.offers?.[0]?.currency,
              null,
            ],
          },
          {
            '!==': [
              props?.data?.item?.offers?.[0]?.currency,
              `BRL`,
            ],
          },
        ],
      }),
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      props: {
        className: `mx-md mt-xsm`,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-7-children-import-taxes-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-7-children-coupon-code-3': {
      name: `CouponCode`,
      from: `@magalu/ecomm-components/components/CouponCode`,
      props: {
        className: `text-on-surface-3 px-md py-xsm`,
        couponName: props?.data?.item?.couponTag?.code,
        expirationDate: props?.data?.item?.couponTag?.endDate,
        expirationMessage: `Copie o cupom e cole na revisão. Válido até`,
        discountValue: props?.data?.item?.couponTag?.discountValue,
        discountType: props?.data?.item?.couponTag?.discountType,
        message: props?.data?.item?.couponTag?.message,
        pageType: props?.route?.name,
      },
      show: raveExp({
        '===': [
          props?.data?.item?.couponTag?.type,
          `coupon`,
        ],
      }),
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-7-children-coupon-code-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-7-children-cdccard-rave-4': {
      name: `CDCCardRave`,
      from: `@magalu/ecomm-components/rave/CDCCard`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-7-children-cdccard-rave-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-7-children-payment-method-cards-5': {
      name: `PaymentMethodCards`,
      from: `@magalu/ecomm-components/rave/PaymentMethodCards`,
      show: raveExp({
        '||': [
          {
            '??': [
              props?.data?.item?.offers?.[0]?.paymentMethods,
              null,
            ],
          },
          {
            '??': [
              props?.data?.item?.offers?.[0]?.bestInstallmentPlan,
              null,
            ],
          },
        ],
      }),
      placeholder: {
        name: `Skeleton`,
        from: `@magalu/ecomm-components/components/Skeleton`,
        props: {
          className: `flex justify-center mt-lg h-screen mx-md`,
          config: {
            color: `#B8C1C4`,
            body: [
              [
                {
                  x: 0,
                  y: 0,
                  width: 100,
                  height: 60,
                  radius: 4,
                },
              ],
              [
                {
                  x: 116,
                  y: 0,
                  width: 100,
                  height: 60,
                  radius: 4,
                },
              ],
              [
                {
                  x: 232,
                  y: 0,
                  width: 100,
                  height: 60,
                  radius: 4,
                },
              ],
              [
                {
                  x: 464,
                  y: 0,
                  width: 100,
                  height: 60,
                  radius: 4,
                },
              ],
            ],
          },
        },
        id: `content-row-7-children-payment-method-cards-5-placeholder`,
      },
      props: {
        className: `pb-sm gap-md`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-7-children-payment-method-cards-5`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-7-children-tab-installments-6': {
      name: `TabInstallments`,
      from: `@magalu/ecomm-components/rave/TabInstallments`,
      show: raveExp({
        '||': [
          {
            '??': [
              props?.data?.item?.offers?.[0]?.paymentMethods,
              null,
            ],
          },
          {
            '??': [
              props?.data?.item?.offers?.[0]?.bestInstallmentPlan,
              null,
            ],
          },
        ],
      }),
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-7-children-tab-installments-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-9-children-shipping-0': {
      name: `Shipping`,
      from: `@magalu/ecomm-components/rave/Shipping`,
      show: props?.data?.item?.available,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      props: {
        actionLabel: `calcular`,
        changeLabel: `alterar`,
        maxCityLength: 24,
        placeholder: `Calcular frete e prazo`,
        salesChannelId: raveIf([
          raveExp({
            '==': [
              props?.route?.deviceInfo?.platform,
              `iOS`,
            ],
          }),
          `54`,
          `53`,
        ]),
        organizationId: `magazine_luiza`,
        className: `p-md`,
        showCloseness: true,
      },
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-9-children-shipping-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-9-children-let-me-know-1': {
      name: `LetMeKnow`,
      from: `@magalu/ecomm-components/rave/LetMeKnow`,
      hide: props?.data?.item?.available,
      props: {
        origin: `pdp-mobile`,
        success: `Cadastro realizado com sucesso. Em breve, você receberá um e-mail de confirmação.`,
        className: `px-md mb-sm`,
      },
      csr: false,
      displayCondition: `hide`,
      hasSpacing: false,
      id: `content-row-9-children-let-me-know-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-10-children-services-buy-button-0': {
      name: `ServicesBuyButton`,
      from: `@magalu/ecomm-components/rave/ServicesBuyButton`,
      props: {
        label: `Ver produtos e preços`,
        servicesPageLink: `https://m.magazineluiza.com.br/servico/pedidos-elegiveis/${props?.data?.item?.id}`,
        className: `px-md`,
        cartUrl: {
          default: `https://sacolamobile.magazineluiza.com.br/#/endereco`,
          login: `https://sacolamobile.magazineluiza.com.br/#/cliente/login`,
        },
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-10-children-services-buy-button-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-11-children-closeness-0': {
      name: `Closeness`,
      from: `@magalu/ecomm-components/rave/Closeness`,
      show: props?.data?.item?.available,
      props: {
        minValues: {
          international: 199,
          market: 199,
          default: 79,
        },
        availableSellers: [
          `paduamed`,
          `soldiersnutrition`,
          `nawebutilidade`,
          `sandrinimenswear`,
          `vitaesaude`,
          `brinquei`,
          `ricari`,
          `tubaraocentermg`,
          `imortalsuplementos`,
          `cgm-store`,
          `onyonstore`,
          `maxxmercadinho`,
          `mmhouse`,
          `utilcomvariedades`,
          `devintexcosmeticos`,
          `denavitta`,
          `lojasmontrecomerciosltda`,
          `kasm`,
          `esquilosshop`,
          `bellvolpebrasile`,
          `byamendoeira`,
          `magaprimer`,
          `fvenxovaisltda`,
          `homeimports`,
          `lojasestreladolar`,
          `ddmaquinas`,
          `dubaiimportadoraedistribuidora`,
          `lojatotalmobile`,
          `cnmshop2`,
          `jdmazine`,
          `comfortenxovaisltda`,
          `ismaferferramentas`,
          `nybcloja`,
          `eletromassa`,
          `shalombrasilvariedades`,
          `casadege`,
          `loibrasil`,
          `useebrasil`,
          `planetadobebe`,
          `cozinhashow`,
          `trevizosuplementos`,
        ],
        className: `mx-md mb-md`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-11-children-closeness-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-11-children-buy-buttons-1': {
      name: `BuyButtons`,
      from: `@magalu/ecomm-components/rave/BuyButtons`,
      props: {
        useCustomerId: true,
        bagButton: {
          icon: `shopping-bag`,
          label: `Adicionar à sacola`,
        },
        buyButton: {
          outline: true,
          label: `Comprar agora`,
        },
        storeButton: {
          label: `Retire na loja!`,
          secondary: ``,
        },
        servicesPageLink: `https://m.magazineluiza.com.br/produto/seguros/${props?.data?.item?.id}/`,
        channel: `MSITE`,
        cartUrl: {
          default: `https://sacolamobile.magazineluiza.com.br/#/endereco`,
          addToBag: `https://sacolamobile.magazineluiza.com.br/#`,
          floatButton: `https://sacolamobile.magazineluiza.com.br/#`,
          pickupStore: `https://sacolamobile.magazineluiza.com.br/#/endereco?tipo=retira-loja`,
          login: `https://sacolamobile.magazineluiza.com.br/#/cliente/login`,
        },
        className: `px-md`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-11-children-buy-buttons-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-11-children-alert-list-2': {
      name: `AlertList`,
      from: `@magalu/ecomm-components/components/AlertList`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-11-children-alert-list-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-12-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Veja também outras opções`,
        as: `h2`,
        className: `text-on-surface-2 pb-md font-md-bold px-md`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-12-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-12-children-buy-box-1': {
      name: `BuyBox`,
      from: `@magalu/ecomm-components/rave/BuyBox`,
      props: {
        salesChannelId: `9`,
        organizationId: `magazine_luiza`,
        toggleAutoShipping: `AUTO`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-12-children-buy-box-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-12-children-row-2': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `border-t-thin border-on-surface-8`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-12-children-row-2`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-12-children-row-2-children-button-0': {
      name: `Button`,
      from: `@magalu/ecomm-components/rave/Button`,
      props: {
        full: true,
        variant: `invisible`,
        label: `Veja mais opções`,
        pushToSiteDomain: false,
        spa: true,
        href: raveReplace([
          props?.data?.item?.path,
          `/p`,
          `/m`,
        ]),
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-12-children-row-2-children-button-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-14-children-tab-product-detail-0': {
      name: `TabProductDetail`,
      from: `@magalu/ecomm-components/rave/TabProductDetail`,
      props: {
        label: `Informações do Produto`,
        detailTitle: `Detalhes do Produto`,
        className: `px-md`,
        brandLink: false,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-14-children-tab-product-detail-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-16-children-seller-info-0': {
      name: `SellerInfo`,
      from: `@magalu/ecomm-components/rave/SellerInfo`,
      props: {
        className: `mx-md`,
        showChatButton: true,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-16-children-seller-info-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-18-children-benefits-0': {
      name: `Benefits`,
      from: `@magalu/ecomm-components/rave/Benefits`,
      props: {
        direction: `vertical`,
        className: `mx-md`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-18-children-benefits-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-18-children-report-button-1': {
      name: `ReportButton`,
      from: `@magalu/ecomm-components/rave/ReportButton`,
      show: raveExp({
        '!==': [
          props?.data?.item?.offers?.[0]?.seller?.id,
          `magazineluiza`,
        ],
      }),
      props: {
        children: `Denunciar Anúncio`,
        href: `/denuncie/${props?.data?.item?.id}/?from=${props?.route?.asPath}`,
        className: `mt-xsm mx-md`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-18-children-report-button-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-20-children-ads-banner-0': {
      name: `AdsBanner`,
      from: `@magalu/ecomm-components/rave/AdsBanner`,
      csr: {
        strategy: `onLazyLoading`,
        props: {
          temporary: {
            className: `min-h-[64px]`,
          },
        },
      },
      props: {
        className: `w-full`,
        categories: [
          props?.data?.item?.category?.id,
        ],
        slot: `PDP_banner_mobile`,
        page: props?.route?.name,
        position: 5,
        size: `small`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-20-children-ads-banner-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-22-children-empty-review-button-0': {
      name: `EmptyReviewButton`,
      from: `@magalu/ecomm-components/rave/EmptyReviewButton`,
      hide: true,
      props: {
        title: `Seja o primeiro a avaliar esse produto`,
        subtitle: `Esse produto ainda não tem avaliação`,
        className: `mx-xlg pb-lg pt-lg`,
        button: {
          label: `Avaliar o produto`,
          as: `a`,
          variant: `outline`,
          className: `font-sm-medium`,
          size: `medium`,
          href: `/r/${props?.route?.query?.slug}/${props?.route?.query?.productId}/${props?.route?.query?.categoryId}/${props?.route?.query?.subCategoryId}/`,
          navigationParams: `{ type: 'review', data: { sku: ${props?.data?.item?.id}, category: { id: ${props?.data?.item?.category?.id}, sub_category: { id: ${props?.data?.item?.subcategory?.id} }, action: 'create'}`,
        },
      },
      csr: false,
      displayCondition: `hide`,
      hasSpacing: false,
      id: `content-row-22-children-empty-review-button-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-22-children-row-1': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.productRating?.userReviews?.items,
      props: {
        className: `flex-col gap-md px-md mb-md`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-22-children-row-1`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-22-children-row-1-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Avaliações dos clientes`,
        as: `h2`,
        className: `font-md-bold`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-22-children-row-1-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-22-children-row-1-children-review-stats-1': {
      name: `ReviewStats`,
      from: `@magalu/ecomm-components/rave/ReviewStats`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-22-children-row-1-children-review-stats-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-22-children-row-1-children-product-review-media-carousel-2': {
      name: `ProductReviewMediaCarousel`,
      from: `@magalu/ecomm-components/components/ProductReviewMediaCarousel`,
      show: raveExp({
        '||': [
          {
            '??': [
              props?.data?.productRating?.userReviews?.items?.[0]?.product?.images?.[0],
              null,
            ],
          },
          {
            '??': [
              props?.data?.productRating?.userReviews?.items?.[0]?.product?.videos?.[0],
              null,
            ],
          },
        ],
      }),
      props: {
        title: `Avaliações com fotos e vídeos`,
        items: props?.data?.productRating?.userReviews?.items,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-22-children-row-1-children-product-review-media-carousel-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-22-children-row-1-children-review-listing-3': {
      name: `ReviewListing`,
      from: `@magalu/ecomm-components/rave/ReviewListing`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-22-children-row-1-children-review-listing-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-22-children-row-2': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.productRating?.userReviews?.items,
      props: {
        className: `flex-col gap-xlg border-t-thin border-on-surface-8`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-22-children-row-2`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-22-children-row-2-children-review-see-more-0': {
      name: `ReviewSeeMore`,
      from: `@magalu/ecomm-components/rave/ReviewSeeMore`,
      props: {
        path: `/review/${props?.route?.query?.productId}/${props?.route?.query?.slug}/${props?.route?.query?.categoryId}/${props?.route?.query?.subCategoryId}`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-22-children-row-2-children-review-see-more-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-24-children-questions-list-0': {
      name: `QuestionsList`,
      from: `@magalu/ecomm-components/rave/QuestionsList`,
      props: {
        emptyPhrase: `Nenhuma pergunta foi feita ainda. Seja o primeiro!`,
        title: `Perguntas e Respostas`,
        className: `mt-md`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-24-children-questions-list-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-24-children-question-form-1': {
      name: `QuestionForm`,
      from: `@magalu/ecomm-components/rave/QuestionForm`,
      props: {
        label: `Tire sua dúvida com a loja sobre o produto`,
        placeholder: `Escreva aqui sua dúvida...`,
        totalQuestions: props?.data?.questions?.totalQuestions,
        questionsLimit: 3,
        buttonText: {
          authenticated: `Enviar pergunta`,
          unauthenticated: `Fazer uma pergunta`,
        },
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-24-children-question-form-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-24-children-question-confirm-2': {
      name: `QuestionConfirm`,
      from: `@magalu/ecomm-components/rave/QuestionConfirm`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-24-children-question-confirm-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-24-children-question-feedback-3': {
      name: `QuestionFeedback`,
      from: `@magalu/ecomm-components/rave/QuestionFeedback`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-24-children-question-feedback-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-24-children-divider-4': {
      name: `Divider`,
      from: `@magalu/ecomm-components/components/Divider`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      props: {
        orientation: `horizontal`,
        thickness: `thin`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-24-children-divider-4`,
      spacing: {
      },
      ssr: false,
    },
    'content-row-24-children-divider-4-children-question-see-more-0': {
      name: `QuestionSeeMore`,
      from: `@magalu/ecomm-components/rave/QuestionSeeMore`,
      show: raveExp({
        '>': [
          props?.data?.questions?.totalQuestions,
          3,
        ],
      }),
      props: {
        className: `px-md btn-lg`,
        label: `Ver mais ou fazer uma pergunta`,
        href: `/q/a/${props?.route?.query?.productId}/${props?.route?.query?.slug}/${props?.route?.query?.categoryId}/${props?.route?.query?.subCategoryId}`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-24-children-divider-4-children-question-see-more-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-26-children-faq-0': {
      name: `Faq`,
      from: `@magalu/ecomm-components/rave/Faq`,
      show: props?.data?.seoPdpContent?.faq,
      props: {
        className: `px-md`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-26-children-faq-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-version-tag-0': {
      name: `VersionTag`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `footer-version-tag-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-back-to-top-1': {
      name: `BackToTop`,
      from: `@magalu/ecomm-components/components/BackToTop`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `footer-back-to-top-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-zip-code-bar-1-placeholder': {
      name: `Skeleton`,
      from: `@magalu/ecomm-components/components/Skeleton`,
      props: {
        className: `flex justify-center pt-xsm h-[40px] mx-md`,
        config: {
          color: `#B8C1C4`,
          body: [
            [
              {
                x: 0,
                y: 0,
                width: `100%`,
                height: 32,
                radius: 4,
              },
            ],
          ],
        },
      },
      id: `content-zip-code-bar-1-placeholder`,
    },
    'content-row-4-children-media-gallery-0-placeholder': {
      name: `Skeleton`,
      from: `@magalu/ecomm-components/components/Skeleton`,
      props: {
        className: `flex justify-center mx-md mt-lg h-[320px]`,
        config: {
          color: `#B8C1C4`,
          body: [
            [
              {
                x: 0,
                y: 0,
                width: `100%`,
                height: 320,
                radius: 10,
              },
            ],
          ],
        },
      },
      id: `content-row-4-children-media-gallery-0-placeholder`,
    },
    'content-row-5-children-row-0-children-rating-1-placeholder': {
      name: `Skeleton`,
      from: `@magalu/ecomm-components/components/Skeleton`,
      props: {
        config: {
          color: `#B8C1C4`,
          body: [
            [
              {
                x: 0,
                y: 0,
                width: 200,
                height: 10,
                radius: 2,
              },
            ],
          ],
        },
      },
      id: `content-row-5-children-row-0-children-rating-1-placeholder`,
    },
    'content-row-5-children-heading-1-placeholder': {
      name: `Skeleton`,
      from: `@magalu/ecomm-components/components/Skeleton`,
      props: {
        className: `flex justify-center h-[20px] mx-md mt-md`,
        config: {
          color: `#B8C1C4`,
          body: [
            [
              {
                x: 0,
                y: 0,
                width: 600,
                height: 10,
                radius: 2,
              },
            ],
          ],
        },
      },
      id: `content-row-5-children-heading-1-placeholder`,
    },
    'content-row-5-children-attribute-selector-3-placeholder': {
      name: `Skeleton`,
      from: `@magalu/ecomm-components/components/Skeleton`,
      props: {
        className: `flex justify-center mt-lg h-[100px] mx-md`,
        config: {
          color: `#B8C1C4`,
          body: [
            [
              {
                x: 0,
                y: 0,
                width: 60,
                height: 60,
                radius: 4,
              },
            ],
            [
              {
                x: 0,
                y: 68,
                width: 60,
                height: 10,
                radius: 2,
              },
            ],
            [
              {
                x: 72,
                y: 0,
                width: 60,
                height: 60,
                radius: 4,
              },
            ],
            [
              {
                x: 72,
                y: 68,
                width: 60,
                height: 10,
                radius: 2,
              },
            ],
            [
              {
                x: 144,
                y: 0,
                width: 60,
                height: 60,
                radius: 4,
              },
            ],
            [
              {
                x: 144,
                y: 68,
                width: 60,
                height: 10,
                radius: 2,
              },
            ],
            [
              {
                x: 216,
                y: 0,
                width: 60,
                height: 60,
                radius: 4,
              },
            ],
            [
              {
                x: 216,
                y: 68,
                width: 60,
                height: 10,
                radius: 2,
              },
            ],
          ],
        },
      },
      id: `content-row-5-children-attribute-selector-3-placeholder`,
    },
    'content-row-5-children-sell-and-deliver-info-5-placeholder': {
      name: `Skeleton`,
      from: `@magalu/ecomm-components/components/Skeleton`,
      props: {
        className: `flex justify-center mt-md h-[40px] mx-md`,
        config: {
          color: `#B8C1C4`,
          body: [
            [
              {
                x: 0,
                y: 0,
                width: 100,
                height: 10,
                radius: 2,
              },
            ],
            [
              {
                x: 0,
                y: 20,
                width: 200,
                height: 10,
                radius: 2,
              },
            ],
          ],
        },
      },
      id: `content-row-5-children-sell-and-deliver-info-5-placeholder`,
    },
    'content-row-7-children-product-price-0-placeholder': {
      name: `Skeleton`,
      from: `@magalu/ecomm-components/components/Skeleton`,
      props: {
        className: `flex justify-center mt-xsm h-[60px] mx-md`,
        config: {
          color: `#B8C1C4`,
          body: [
            [
              {
                x: 0,
                y: 0,
                width: 400,
                height: 10,
                radius: 2,
              },
            ],
            [
              {
                x: 0,
                y: 16,
                width: 250,
                height: 10,
                radius: 2,
              },
            ],
            [
              {
                x: 0,
                y: 32,
                width: 100,
                height: 10,
                radius: 2,
              },
            ],
          ],
        },
      },
      id: `content-row-7-children-product-price-0-placeholder`,
    },
    'content-row-7-children-payment-method-cards-5-placeholder': {
      name: `Skeleton`,
      from: `@magalu/ecomm-components/components/Skeleton`,
      props: {
        className: `flex justify-center mt-lg h-screen mx-md`,
        config: {
          color: `#B8C1C4`,
          body: [
            [
              {
                x: 0,
                y: 0,
                width: 100,
                height: 60,
                radius: 4,
              },
            ],
            [
              {
                x: 116,
                y: 0,
                width: 100,
                height: 60,
                radius: 4,
              },
            ],
            [
              {
                x: 232,
                y: 0,
                width: 100,
                height: 60,
                radius: 4,
              },
            ],
            [
              {
                x: 464,
                y: 0,
                width: 100,
                height: 60,
                radius: 4,
              },
            ],
          ],
        },
      },
      id: `content-row-7-children-payment-method-cards-5-placeholder`,
    },
  });

export const dataSource = {
  "graphql": {
    "configsDir": "config",
    "host": "https://federation.magazineluiza.com.br",
    "timeout": 5000
  }
}

export const getHeadProps = (props) => ({
    links: [
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/fonts/magalu-ui-variable/files/MagaluUIVariable.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/truetype`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.ttf`,
        crossOrigin: ``,
      },
      {
        rel: `canonical`,
        href: raveExp({
          '??': [
            props?.data?.seoPdpContent?.meta?.canonical,
            `https://www.magazineluiza.com.br${props?.data?.item?.path}`,
          ],
        }),
      },
    ],
    title: raveJoin([
      [
        raveExp({
          '??': [
            props?.data?.seoPdpContent?.meta?.title,
            props?.data?.item?.title,
          ],
        }),
        raveIf([
          props?.data?.item?.reference,
          ` - ${props?.data?.item?.reference}`,
        ]),
        ` - ${props?.data?.item?.subcategory?.name}`,
        ` - Magazine Luiza`,
      ],
    ]),
    meta: [
      {
        name: `description`,
        content: raveJoin([
          [
            raveExp({
              '??': [
                props?.data?.seoPdpContent?.meta?.description,
                props?.data?.item?.title,
              ],
            }),
            ` com as melhores condições você encontra no site do Magalu. Confira!`,
          ],
        ]),
      },
      {
        name: `keywords`,
        content: `${props?.data?.item?.title}, ${props?.data?.item?.category?.name} em oferta, ${props?.data?.item?.category?.name} baratos, promoção de ${props?.data?.item?.category?.name}, ${props?.data?.item?.subcategory?.name} em oferta, ${props?.data?.item?.subcategory?.name} baratos, promoção de ${props?.data?.item?.subcategory?.name}`,
      },
      {
        property: `og:title`,
        content: raveJoin([
          [
            raveExp({
              '??': [
                props?.data?.seoPdpContent?.meta?.title,
                props?.data?.item?.title,
              ],
            }),
            raveIf([
              props?.data?.item?.reference,
              ` - ${props?.data?.item?.reference}`,
            ]),
            ` - ${props?.data?.item?.subcategory?.name}`,
            ` - Magazine Luiza`,
          ],
        ]),
      },
      {
        property: `og:description`,
        content: raveJoin([
          [
            raveExp({
              '??': [
                props?.data?.seoPdpContent?.meta?.title,
                props?.data?.item?.title,
              ],
            }),
            ` com as melhores condições você encontra no site do Magalu. Confira!`,
          ],
        ]),
      },
      {
        property: `og:image`,
        content: raveReplace([
          raveReplace([
            props?.data?.item?.image,
            `{w}`,
            `470`,
          ]),
          `{h}`,
          `352`,
        ]),
      },
      {
        property: `og:type`,
        content: `website`,
      },
      {
        property: `og:site_name`,
        content: `Magazine Luiza`,
      },
      {
        property: `og:url`,
        content: `https://www.magazineluiza.com.br${props?.data?.item?.path}`,
      },
    ],
  });

export const componentsList = [
  "Preconnect",
  "Datadog",
  "Script",
  "AllIn",
  "Criteo",
  "TikTok",
  "RTBHouse",
  "Stewie",
  "SpotifyAdAnalytics",
  "Hotjar",
  "Loader",
  "StateLoader",
  "EventPageViewDispatcher",
  "PageLoading",
  "AdsResolver",
  "ZipCodeBar",
  "ZipCodeModal",
  "Showcase",
  "Row",
  "TradeIn",
  "SummaryFactsheet",
  "ReviewSummary",
  "AdsShowcase",
  "MediaGallery",
  "SellerChatButton",
  "SocialShare",
  "FavoriteButton",
  "ClosenessTag",
  "Rating",
  "Heading",
  "AlertAttributeMessage",
  "AttributeSelector",
  "OfferTimerTag",
  "SellAndDeliverInfo",
  "SellerDetail",
  "ProductPrice",
  "ProductTags",
  "ImportTaxes",
  "CouponCode",
  "CDCCardRave",
  "PaymentMethodCards",
  "TabInstallments",
  "Shipping",
  "LetMeKnow",
  "ServicesBuyButton",
  "Closeness",
  "BuyButtons",
  "AlertList",
  "BuyBox",
  "Button",
  "TabProductDetail",
  "SellerInfo",
  "Benefits",
  "ReportButton",
  "AdsBanner",
  "EmptyReviewButton",
  "ReviewStats",
  "ProductReviewMediaCarousel",
  "ReviewListing",
  "ReviewSeeMore",
  "QuestionsList",
  "QuestionForm",
  "QuestionConfirm",
  "QuestionFeedback",
  "Divider",
  "QuestionSeeMore",
  "Faq",
  "VersionTag",
  "BackToTop",
  "Skeleton"
];

export const routeInfo = {
  id: 'product',
  name: 'produto',
  pathPattern: '/:slug/p/:productId/:categoryId/:subCategoryId/',
  pathAliases: {
  "path0": "slug",
  "path2": "productId",
  "path3": "categoryId",
  "path4": "subCategoryId"
},
  parser: {
    query: {
      "seller_id": unique(),
    },
    cookie: {},
  },
  renderMethod: 'SSR',
  forwardCookies: '',
  forwardHeaders: 'user-agent,referer,theme,x-forwarded-for'
};

export const manifest = {
  "useTypescript": true,
  "deepLinkHost": "https://m.magazineluiza.com.br",
  "isMiniApp": true
};

export const getGlobalClassName = props => ([
    `bg-surface-container-low`,
  ]).join(' ').trim();

export const getPageVariables = props => ({
    item_itemId: props?.route?.query?.productId,
    item_includeTerms: true,
    item_maxSellers: 4,
    item_termsSize: 3,
    item_offerOptions: {
      showPaymentMethods: true,
      sellerId: props?.route?.query?.seller_id,
      campaignCode: props?.route?.cookie?.MLPARCEIRO,
      customerId: props?.data?.userInfo?.id,
      isLoyalty: props?.data?.userInfo?.isLoyalty,
    },
    keySellingPoint_navigationId: props?.route?.query?.productId,
    reviewSummaryQuery_productId: props?.route?.query?.productId,
    productRating_variationId: props?.route?.query?.productId,
    productRating_includeUserReviews: true,
    productRating_hasTag: true,
    seoPdpContent_productId: props?.route?.query?.productId,
    questions_org: `vertical-seller`,
    questions_itemsPerPage: 8,
    questions_questionVariationId: props?.route?.query?.productId,
  });

export const middlewaresArgs = ({ 
      "getAppTheme": (props) => ({
  }),
      "webViewValidator": (props) => ({
    redirectUrl: `/404/`,
  }),
      "getUserInfo": (props) => ({
  }),
      "getVersions": (props) => ({
  }),
      "writePromoterIdCookie": (props) => ({
  }),
      "setPromoterCartExtensions": (props) => ({
  }),
      "parseAdsData": (props) => ({
    channelCode: raveIf([
      raveExp({
        '==': [
          props?.route?.deviceInfo?.platform,
          `iOS`,
        ],
      }),
      `H.IOS`,
      `H.ANDROID`,
    ]),
    showcases: [
      {
        consumer: `mobile`,
        limit: 6,
        slot: `pdp_pp`,
        page: `PDP`,
        channel: `MSITE`,
      },
    ],
    banners: [
      {
        consumer: `mobile`,
        categories: [
          props?.data?.item?.category?.id,
        ],
        limit: 1,
        slot: `PDP_banner_mobile`,
      },
    ],
  }),
      "itemAttributeMapper": (props) => ({
  }),
      "getProductAlerts": (props) => ({
  }),
      "getCouponTag": (props) => ({
  }),
 });

export const config = {
  assetPrefix: '',
};
